/**
 *
 * @param {Object} opts
 * @param {Object} opts.mockError
 * @param {Object} opts.mockResponse
 * @param {Object} opts.mockDelay - request timing
 * @returns {Object}
 */
const mockRequest = (opts) => {
  let timer
  let handler

  const req = {
    end(callback) {
      // set handler from createResponseHandler's req.end((err, res) => { ...
      handler = callback
    },
    abort() {
      clearTimeout(timer)
    },
  }

  timer = setTimeout(() => {
    const statusCode = opts.mockError ? 403 : 200

    handler(opts.mockError, {
      statusCode,
      ...opts.mockResponse || { body: {} },
    })
  }, opts.mockDelay || 500)

  return req
}


export default mockRequest
